import React, { memo, useCallback } from "react";

import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { Column } from "components/Layout";
import TabRow from "components/TabSelector/TabRow";

import { userTypes } from "constants/users";

import { SecurityTrimmedNavigationTab } from "containers/LivestockSales/SecurityTrimmedNavigationTab";

import { isUserOfType } from "lib/auth";
import {
  getLivestockSaleId,
  getSaleyardAuctionRoute,
  getSaleyardName,
} from "lib/navigation";

import { getAuth } from "selectors";

import { useHasBillingRelatedPermissions } from "hooks";

const getTabs = (auth, hasBillingRelatedPermission) => [
  {
    id: "billing",
    title: "Billing",
    display: Boolean(
      isUserOfType([userTypes.LIVESTOCK_AGENT, userTypes.SALEYARD_ADMIN], auth),
    ),
    component: SecurityTrimmedNavigationTab,
    hasPermissionSelector: () => hasBillingRelatedPermission,
  },
];

function ReferenceSaleTabsComponent() {
  const auth = useSelector(getAuth);

  const hasBillingRelatedPermission = useHasBillingRelatedPermissions();

  const { params } = useRouteMatch();
  const history = useHistory();

  const setSection = useCallback(
    section => {
      history.push(
        `${getSaleyardAuctionRoute(
          getSaleyardName(),
          getLivestockSaleId(),
        )}/${section}`,
      );
    },
    [history],
  );

  const { section } = params;

  return (
    <Column printHidden>
      <TabRow
        tabs={getTabs(auth, hasBillingRelatedPermission)}
        selectedTab={section}
        setSelectedTab={setSection}
        backgroundColor="gray95"
      />
    </Column>
  );
}

export default memo(ReferenceSaleTabsComponent);
